import React, { useEffect, useState } from "react";
import { Container } from "./style";
import Button from "../../../../components/FormElement/Button";
import ImageUpload from "../../../../components/FormElement/ImageUpload";
import LangTab from "../../../../components/FormElement/LangTab";
import { useFormik } from "formik";
import { useShowAlert } from "../../../../hooks/useAlerts";
import * as Yup from "yup";
import Spinner from "../../../../components/Spinner/FullScreen";
import service from "../../../../services/customers";
import { useHideModal } from "../../../../hooks";
import URLInput from "../../../../components/FormElement/URl";
import Search from "../../../../components/FormElement/Search";

const Form = ({ id, fetch }) => {
  const { hideModal } = useHideModal();
  const [language, setLanguage] = useState("UZL");
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  const { error } = useShowAlert();

  const validationSchema = Yup.object({
    title: Yup.object().shape({
      UZL: Yup.string().required("Kiritish shart!"),
      UZK: Yup.string().required("Kiritish shart!"),
      RUS: Yup.string().required("Kiritish shart!"),
      ENG: Yup.string().required("Kiritish shart!"),
    }),

    link: Yup.string().required("Kiritish shart!"),
  });

  const formik = useFormik({
    initialValues: {
      title: {
        UZL: "",
        UZK: "",
        RUS: "",
        ENG: "",
      },

      link: "",
    },
    validationSchema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("title[UZL]", values.title.UZL);
      formData.append("title[RUS]", values.title.RUS);
      formData.append("title[UZK]", values.title.UZK);
      formData.append("title[ENG]", values.title.ENG);
      formData.append("link", values.link);
      fileList?.forEach((el) => {
        if (el.originFileObj) {
          formData.append(`file`, el.originFileObj);
        }
      });
      setLoading(true);
      if (id) {
        service
          .update(id, formData)
          .then(() => {
            hideModal();
            fetch();
          })
          .catch((err) => {
            console.log(err);
            error(
              "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
            );
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        service
          .create(formData)
          .then(() => {
            hideModal();
            fetch();
          })
          .catch((err) => {
            console.log(err);
            error(
              "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
            );
          })
          .finally(() => {
            setLoading(false);
          });
      }
    },
  });

  useEffect(() => {
    if (id) {
      setLoading(true);
      service
        .getOne(id)
        .then((resp) => {
          formik.setValues({
            title: {
              UZL: resp?.title?.UZL,
              UZK: resp?.title?.UZK,
              RUS: resp?.title?.RUS,
              ENG: resp?.title?.ENG,
            },

            link: resp?.link,
          });
          resp?.photo && setFileList([resp?.photo]);
        })
        .catch((err) => {
          console.log(err);
          error(
            "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);
  const onLangChange = (key) => {
    setLanguage(key);
  };

  if (loading) return <Spinner />;
  return (
    <Container>
      <form onSubmit={formik.handleSubmit}>
        <LangTab defaultActiveKey="1" onChange={onLangChange} />
        <div className="input-wrapper">
          <Search
            id="title"
            name="title"
            label="Mijoz nomi"
            width={100}
            placeholder="Mijoz nomi"
            onChange={(e) => {
              formik.setFieldValue(`title.${language}`, e.target.value);
            }}
            value={formik.values?.title[language]}
            status={
              formik?.errors?.title && formik.touched.title ? "error" : ""
            }
            height={"44px"}
          />
        </div>

        <div className="input-wrapper">
          <URLInput
            label="Havola"
            value={formik?.values?.link}
            onChange={(e) => {
              const value = e.target.value;
              const sanitizedValue = value.replace(/^http:\/\//, ""); // Remove "http://"
              formik.setFieldValue("link", sanitizedValue); // Update Formik field
            }}
            name="link"
            status={formik?.errors?.link && formik.touched.link ? "error" : ""}
          />{" "}
        </div>
        <div className="upload-wrapper">
          <ImageUpload
            maxCount={1}
            multiple={true}
            fileList={fileList}
            setFileList={setFileList}
            status={status && !fileList?.length ? true : false}
          />
        </div>
        <Button
          text={id ? "Tahrirlash" : "Saqlash"}
          htmlType="submit"
          width="100%"
        />
      </form>
    </Container>
  );
};

export default Form;
